module.exports = __webpack_public_path__ + "static/media/mobile-icons-buttons-page-navigation-left-arrow-disabled.4db1ea34.svg";